import * as z from "zod/v4";

export const updateReturnWithShippingRefund = {
  name: "updateReturnWithShippingRefund" as const,
  input: z.object({
    id: z.string(),
    refundOriginalShipping: z.boolean(),
    refundOriginalShippingAmount: z.number().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
